import { useAuthorization, ROLES } from 'lib/authorization';
import { HomeIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import * as React from 'react';
import { CiViewTimeline } from 'react-icons/ci';
import {
  FileText,
  Users,
  Film,
  BookOpen,
  Briefcase,
  MessageCircle,
  Box,
  File,
} from 'react-feather';
import { NavLink } from 'react-router-dom';
import BikeIcon from 'assets/bike-icon.svg';
import { MapPin } from 'lucide-react';

export const SideNavigation = ({ showLabels = true }) => {
  const { checkAccess } = useAuthorization();
  const navigation = [
    { name: 'Overview', to: '/app', icon: HomeIcon },

    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Accounts',
      to: '/app/accounts',
      icon: Users,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Riders',
      to: '/app/riders',
      icon: <img src={BikeIcon} alt="Bike Icon" className="h-5" />,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Trips',
      to: '/app/trips',
      icon: BookOpen,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Businesses',
      to: '/app/businesses',
      icon: Film,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: "What's happening?",
      to: '/app/posts',
      icon: MessageCircle,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Places',
      to: '/app/places',
      icon: MapPin,
    },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Communities',
    //   to: '/app/communities',
    //   icon: Briefcase,
    // },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Issues',
      to: '/app/issues',
      icon: CiViewTimeline,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Payments',
      to: '/app/payments',
      icon: CiViewTimeline,
    },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Transactions',
      to: '/app/transactions',
      icon: CiViewTimeline,
    },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Services',
    //   to: '/app/services',
    //   icon: CiViewTimeline,
    // },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Analytics',
    //   to: '/app/analytics',
    //   icon: CiViewTimeline,
    // },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Integrations',
    //   to: '/app/integrations',
    //   icon: CiViewTimeline,
    // },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Reports',
    //   to: '/app/reports',
    //   icon: CiViewTimeline,
    // },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'Promotions',
    //   to: '/app/promotions',
    //   icon: CiViewTimeline,
    // },
    // checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
    //   name: 'System Settings',
    //   to: '/app/system',
    //   icon: CiViewTimeline,
    // },
    checkAccess({ allowedRoles: [ROLES.ADMIN] }) && {
      name: 'Activity Logs',
      to: '/app/logs',
      icon: FileText,
    },
  ].filter(Boolean);

  return (
    <>
      {navigation.map((item, index) => (
        <div key={index}>
          {item.heading && (
            <p
              key={index}
              className="px-3 py-4 my-2 text-xs flex flex-row font-sm text-blue-300 uppercase tracking-wider"
            >
              <span>{showLabels && item.heading}</span>
            </p>
          )}
          <NavLink
            end={index === 0}
            key={item.name}
            to={item.to}
            className={clsx(
              'text-white  hover:font-black hover:text-white hover:bg-white/50',
              'group flex items-center px-2 py-2 text-sm font-medium rounded-md mb-3'
            )}
          >
            <div className="flex flex-col">
              <div className="flex">
                {item.name === 'Riders' ? (
                  <div className="mr-4 flex-shrink-0 h-6 w-6">{item.icon}</div>
                ) : (
                  <item.icon
                    className={clsx(
                      'text-white group-hover:text-white hover:font-black',
                      'mr-4 flex-shrink-0 h-6 w-6'
                    )}
                    aria-hidden="true"
                  />
                )}
                {showLabels && <span className="text-sm">{item.name}</span>}
              </div>
            </div>
          </NavLink>
        </div>
      ))}
    </>
  );
};
